export default __webpack_public_path__ + "static/media/no-user-assigned.1e32e42e.svg";